import { seoData, type seoPageTypes } from './Seo.helpers';

export const Seo = ({ page }: { page: seoPageTypes }) => (
	<>
		<title>{seoData[page].title}</title>
		<meta
			name='description'
			content={seoData[page].description}
		/>
	</>
);
